import React from "react";
import { Table } from "antd";
import { SubjectCreateResponse } from "@src/redux/types"; // your output types

interface Props {
  subjectListIterative: {
    items?: SubjectCreateResponse[],
    error?: any,
  } | null;
}

const BulkUploadIterativeList: React.FC<Props> = ({
  subjectListIterative,
}) => {
  const columns = [
    { title: "Reference ID", dataIndex: "referenceId", key: "referenceId" },
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Response", dataIndex: "response", key: "response" },
  ];

  return (
    <Table
      dataSource={subjectListIterative?.items || []}
      columns={columns}
      rowKey="referenceId"
      pagination={false}
      scroll={{ y: 300 }} // optional: scroll for long lists
    />
  );
};

export default BulkUploadIterativeList;
